var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.brands,attrs:{"id":"bu-dealer-brands"}},[_vm._l((_vm.brandsWithLogoData),function(brand){return [_c('RawHtml',{key:brand[_vm.c.ID],attrs:{"template":brand[_vm.c.LOGO_DATA]}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }